export type TicketAssignmentDraft = {
  userId?: string;
  guestName?: string;
  guestEmail?: string;
};

/**
 * A guest ticket is complete only when it has both pieces of identity the
 * server requires. Keeping this check beside the checkout validator prevents
 * the UI's "Assigned" state and the payload gate from drifting apart again.
 */
export const isGuestTicketAssignment = (
  attendee: TicketAssignmentDraft,
): boolean =>
  !attendee.userId &&
  Boolean(attendee.guestName?.trim()) &&
  Boolean(attendee.guestEmail?.trim());

export const isCompleteTicketAssignment = (
  attendee: TicketAssignmentDraft,
): boolean => Boolean(attendee.userId) || isGuestTicketAssignment(attendee);
